module.exports = __webpack_public_path__ + "img/corridoio 2.8eb778a9.jpeg";